import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RobokassaService from '../../services/RobokassaService';

const PaymentFailure: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [errorInfo, setErrorInfo] = useState<{
    amount?: string;
    orderId?: string;
    errorMessage?: string;
  } | null>(null);

  useEffect(() => {
    // Проверяем, есть ли параметры от Robokassa
    const callbackParams = RobokassaService.parseCallbackUrl();

    if (callbackParams) {
      setErrorInfo({
        amount: callbackParams.OutSum,
        orderId: callbackParams.InvId,
      });
    }
  }, []);

  const handleRetry = () => {
    if (errorInfo?.orderId) {
      navigate(`/orders/${errorInfo.orderId}/payment`);
    } else {
      navigate('/orders');
    }
  };

  const handleGoToStore = () => {
    navigate('/fsm/pricing');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleContactSupport = () => {
    navigate('/support');
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card border-danger">
            <div className="card-body text-center">
              <div className="mb-4">
                <i
                  className="fas fa-times-circle text-danger"
                  style={{ fontSize: 80 }}
                />
              </div>

              <h2 className="mb-3 text-danger">
                {t('financial.paymentFailed')}
              </h2>

              <p className="lead mb-4">
                {t('financial.paymentFailedDescription')}
              </p>

              {errorInfo && (
                <div className="alert alert-warning">
                  <h5 className="alert-heading">{t('financial.paymentDetails')}</h5>
                  <hr />
                  <div className="row text-start">
                    {errorInfo.amount && (
                      <>
                        <div className="col-6 mb-2">
                          <strong>{t('financial.amount')}:</strong>
                        </div>
                        <div className="col-6 mb-2 text-end">
                          {errorInfo.amount} ₽
                        </div>
                      </>
                    )}

                    {errorInfo.orderId && (
                      <>
                        <div className="col-6 mb-2">
                          <strong>{t('financial.orderId')}:</strong>
                        </div>
                        <div className="col-6 mb-2 text-end">
                          #{errorInfo.orderId}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              <div className="alert alert-danger">
                <i className="fas fa-exclamation-triangle me-2" />
                <strong>{t('financial.possibleReasons')}:</strong>
                <ul className="mb-0 mt-2">
                  <li>{t('financial.reason1')}</li>
                  <li>{t('financial.reason2')}</li>
                  <li>{t('financial.reason3')}</li>
                  <li>{t('financial.reason4')}</li>
                </ul>
              </div>

              <div className="d-flex gap-2 justify-content-center mt-4">
                <button
                  className="btn btn-success btn-lg"
                  onClick={handleGoToStore}
                >
                  <i className="fas fa-store me-2" />
                  {t('financial.backToStore')}
                </button>
              </div>

              <div className="d-flex gap-2 justify-content-center mt-3">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleGoHome}
                >
                  <i className="fas fa-home me-2" />
                  {t('home')}
                </button>

                <button
                  className="btn btn-outline-info"
                  onClick={handleContactSupport}
                >
                  <i className="fas fa-headset me-2" />
                  {t('support.contactSupport')}
                </button>

                <button
                  className="btn btn-danger"
                  onClick={handleRetry}
                >
                  <i className="fas fa-redo me-2" />
                  {t('financial.tryAgain')}
                </button>
              </div>
            </div>
          </div>

          {/* Советы по оплате */}
          <div className="card mt-4">
            <div className="card-body">
              <h5 className="card-title">
                <i className="fas fa-lightbulb me-2 text-warning" />
                {t('financial.paymentTips')}
              </h5>
              <ul className="mb-0">
                <li>{t('financial.tip1')}</li>
                <li>{t('financial.tip2')}</li>
                <li>{t('financial.tip3')}</li>
                <li>{t('financial.tip4')}</li>
              </ul>
            </div>
          </div>

          {/* Информация о безопасности */}
          <div className="card mt-4">
            <div className="card-body">
              <h5 className="card-title">
                <i className="fas fa-shield-alt me-2 text-success" />
                {t('financial.securityInfo')}
              </h5>
              <p className="mb-0">
                {t('financial.securityMessage')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
